// Based on /web-components/src/global-header/gntc-global-header.events.ts

const GLOBAL_HEADER_MENU_TOGGLE = 'global-header:menu-toggle';

export enum HeaderMenus {
  SearchNavigation = 'SearchNavigation',
  AppsSection = 'AppsSection',
  LoginSection = 'LoginSection',
  LanguageSection = 'LanguageSection',
  NotificationsSection = 'NotificationsSection',
  GlobalNavigation = 'GlobalNavigation',
}

export const toggleGlobalHeaderOption = (optionMenu: HeaderMenus, toggleValue?: boolean) => {
  const eventDetail = {
    detail: {
      originHeaderMenu: optionMenu,
      toggleVisibilityValue: toggleValue,
      externalTrigger: true,
    },
  };
  const event: CustomEvent = new CustomEvent(GLOBAL_HEADER_MENU_TOGGLE, eventDetail);
  document.dispatchEvent(event);
};
